import { Component, DestroyRef, effect, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { ConsultService } from '@insolution/consult-data-access';
import { IconModule } from '@insolution/core-data-access';
import { CurrentTenantService } from '@insolution/tenant-data-access';
import { TranslatePipe } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'lib-open-consults',
  imports: [TranslatePipe, IconModule, RouterLink],
  templateUrl: './open-consults.html',
  styleUrl: './open-consults.scss',
})
export class OpenConsults {
  private consultService = inject(ConsultService);
  private currentTenantService = inject(CurrentTenantService);
  private destroyRef = inject(DestroyRef);

  protected openConsultsCount = signal(0);

  private setOpenConsultsIsCalled$ = new Subject<void>();

  constructor() {
    effect(() => {
      const tenantId = this.currentTenantService.currentTenantId();

      if (!tenantId) {
        this.setOpenConsultsIsCalled$.next();
        this.openConsultsCount.set(0);
        return;
      }

      this.setOpenConsults(tenantId);
    });
  }

  private setOpenConsults(tenantId: string) {
    this.setOpenConsultsIsCalled$.next();

    this.consultService
      .watchOpenConsultsByTenantId$(tenantId)
      .pipe(takeUntilDestroyed(this.destroyRef), takeUntil(this.setOpenConsultsIsCalled$))
      .subscribe((consults) => this.openConsultsCount.set(consults.length));
  }
}
